import { BehaviorSubject, catchError, map, Observable, of, tap } from "rxjs";
import { ExceptionService } from "src/app/core/exception.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Logger } from "src/app/core/logger";
import { Config } from "src/app/config";

@Injectable({
  providedIn: 'root'
})
export class updateStatusService {
  // Use the service as a state 
  public form$ = new BehaviorSubject({});

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService,
    private logger: Logger
  ) {
  }

  /**
   * 
   * @returns Question Library to be loaded at startup to the palette
   */

  updateStatus(survey): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };

    // const url = environment.endpoints.saveForm;
    // const url = `${Config.app.projectApiUrl}/Form`;
    // let baseurl = environment.endpoints.projectApiUrl;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form/UpdateFormStatus`;
    // return this.http.post(url, survey, options);
    return this.http
        .patch(url, survey, options)
        .pipe(
          map( res => {
            this.logger.log('Response retrieved=' + res);
            return res;
          })
          // ,catchError(res => {
          //  return this.exceptionService.catchBadResponse(res);
          // }) 
          );      
  }

  public getHeaders(needId?: boolean, skipSpinner?: boolean): any {

    const uuid = (): string => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line: no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });


    let headers = new HttpHeaders()
      .append('identity', Config.user.name)
      .append('Content-Type', 'application/json')
      .append('Accept', 'application/json');
    if (needId) {
      headers = headers.append('x-requestid', uuid());
    }

    if (skipSpinner) {
      headers = headers.append('skip-spinner', 'true');
    }
    return headers;
  }
}